/* eslint-disable */
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import withWidth, { isWidthDown, isWidthUp } from '@material-ui/core/withWidth';
import isEmpty from 'lodash/isEmpty';
import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { compose } from 'redux';
import Footer from '../../Components/Footer/Footer.component';
import OrderConcreteDeliveries from '../../Components/OrderConcreteDeliveries/OrderConcreteDeliveries.component';
import OrderDetailsHeader from '../../Components/OrderDetailsHeader/OrderDetailsHeader.component';
import OrderDetailsSideNav from '../../Components/OrderDetailsSideNav/OrderDetailsSideNav.component';
import Page from '../../Components/Page/Page.component';
import orderItemSelector from '../../State/Store/Orders/Selectors/OrderItem.selector';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import { createOrderPageLink } from '../Order/Order.page.route';
import { ORDERS_PAGE_PATH } from '../Orders/Orders.page.route';
import './OrderConcreteDeliveries.page.i18n';
import OrderConcreteDeliveriesPagePropTypes from './OrderConcreteDeliveries.page.props';
import orderConcreteDeliveriesPageStyles from './OrderConcreteDeliveries.page.styles';

/**
 * OrderConcreteDeliveriesPageComponent
 * @export
 * @class OrderConcreteDeliveriesPageComponent
 * @extends {React.Component<OrderConcreteDeliveriesPageComponentComposedProps, OrderConcreteDeliveriesPageComponentState>}
 */
export class OrderConcreteDeliveriesPageComponent extends React.Component {
  /**
   * The `props` to seed when any specific prop receives an `undefined` value. **NOT** a `null` value
   * @static
   * @type {Partial<OrderConcreteDeliveriesPageComponentProps>}
   * @memberof OrderConcreteDeliveriesPageComponent
   */
  static defaultProps = {};

  /**
   * The name of the Component to display when debugging
   * @static
   * @type {`OrderConcreteDeliveriesPage`}
   * @memberof OrderConcreteDeliveriesPageComponent
   */
  static displayName = `OrderConcreteDeliveriesPage`;

  /**
   * The values to use to apply runtime typechecking on the props
   * @static
   * @type {object}
   * @memberof OrderConcreteDeliveriesPageComponent
   */
  static propTypes = OrderConcreteDeliveriesPagePropTypes;

  /**
   * Data specific to the `<OrderConcreteDeliveriesPage />` instance
   * @type {OrderConcreteDeliveriesPageComponentState}
   * @memberof OrderConcreteDeliveriesPageComponent
   */
  state = {};

  /**
   * Render the component
   * @returns {React.Component} The rendered `<OrderConcreteDeliveriesPage />`
   * @memberof OrderConcreteDeliveriesPageComponent
   */
  render() {
    const { currentOrder } = this.props;
    if (isEmpty(currentOrder)) {
      return <Redirect to={ORDERS_PAGE_PATH} />;
    }
    const { classes, orderId, width } = this.props;
    const isSmall = isWidthDown(`xs`, width);
    const isLarge = isWidthUp(`lg`, width);
    return (
      <Page
        heading="OrderConcreteDeliveriesPage.PageTitle"
        hideLogo={isSmall}
        hideMenuIcon={isLarge}
        hideNavbar={isSmall}
        hideSidebar={isSmall}
        padding="none"
        sidebarContent={<OrderDetailsSideNav orderId={orderId} />}
        title="OrderConcreteDeliveriesPage.PageTitle"
      >
        <Grid classes={{ container: classes.container }} container direction="column" wrap="nowrap">
          <OrderDetailsHeader backLink={createOrderPageLink({ orderId })} orderId={orderId} />
          <OrderConcreteDeliveries orderId={orderId} />
          <Grid className={classes.footer}>
            <Footer />
          </Grid>
        </Grid>
      </Page>
    );
  }
}

/** @type {React.ComponentClass<OrderConcreteDeliveriesPageComponentProps>} */
const OrderConcreteDeliveriesPage = compose(
  withWidth(),
  withStyles(themeCreateInjectableStyles(orderConcreteDeliveriesPageStyles), { withTheme: true }),
  connect(() => (state, ownProps) => {
    const { orderId } = ownProps;
    const orderEntitySelector = orderItemSelector(orderId);
    return {
      currentOrder: orderEntitySelector(state),
    };
  }),
)(OrderConcreteDeliveriesPageComponent);

export default OrderConcreteDeliveriesPage;
